import { Box, Paper } from '@mui/material';
import { MessageDirection } from '../ChatBox';

/**
 * Props for the ChatBubble component.
 */
interface ChatBubbleProps {
  /**
   * Indicates the direction of the message (to AI or from AI).
   */
  toFrom: MessageDirection;
  /**
   * The content of the chat message.
   */
  message: string;
}

/**
 * ChatBubble component renders a single chat message bubble.
 */
const ChatBubble = (props: ChatBubbleProps) => {
  return (
    <Box
      width="100%"
      display="flex"
      justifyContent={
        props.toFrom == MessageDirection.toAi ? 'flex-end' : 'flex-start'
      }
    >
      <Box maxWidth="85%">
        <Paper variant="outlined" sx={{ padding: '.5em' }}>
          {props.message.split('\n').map((line, index) => (
            <span key={index}>
              {line}
              <br />
            </span>
          ))}
        </Paper>
      </Box>
    </Box>
  );
};

export default ChatBubble;
